/* ==========================================================================
   Limavia — Base de maquillaje · landing behaviour (scoped, vanilla).
   NO cart logic here — the native product form owns Add to Cart; Kaching owns
   bundle pricing. This only drives visual UI: gallery, accordions, reviews
   carousel, pack cosmetic selection, and the sticky mobile bar.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---- GALLERY ------------------------------------------------------- */
    $$('.bml-gallery').forEach(function (g) {
      var track = $('.bml-gallery__track', g);
      var slides = $$('.bml-gallery__slide', g);
      var thumbs = $$('.bml-thumb', g);
      var count = $('.bml-gallery__count', g);
      if (!track || !slides.length) return;
      var idx = 0;
      function setActive(i) {
        idx = Math.max(0, Math.min(slides.length - 1, i));
        var target = slides[idx];
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === idx); });
        if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
        var at = thumbs[idx];
        if (at && at.parentElement) {
          var strip = at.parentElement;
          strip.scrollTo({ left: at.offsetLeft - strip.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { setActive(ti); }); });
      var prev = $('.bml-gnav--prev', g), next = $('.bml-gnav--next', g);
      if (prev) prev.addEventListener('click', function () { setActive(idx - 1); });
      if (next) next.addEventListener('click', function () { setActive(idx + 1); });
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== idx) {
            idx = i;
            thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === idx); });
            if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
          }
        });
      }, { passive: true });
    });

    /* ---- ACCORDIONS (hero + faq) --------------------------------------- */
    function bindAccordion(headSel, itemSel) {
      $$(headSel).forEach(function (h) {
        h.addEventListener('click', function () {
          var it = h.closest(itemSel);
          if (it) it.classList.toggle('is-open');
        });
      });
    }
    bindAccordion('.bml-acc__head', '.bml-acc');
    bindAccordion('.bml-faq__q', '.bml-faq__it');

    /* ---- PACK cards: cosmetic selection only (Kaching owns real logic) -- */
    $$('.bml-packs').forEach(function (wrap) {
      var packs = $$('.bml-pack', wrap);
      packs.forEach(function (p) {
        p.addEventListener('click', function () {
          packs.forEach(function (o) {
            var on = o === p;
            o.classList.toggle('is-sel', on);
            o.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          var price = p.getAttribute('data-price');
          if (price) updateStickyPrice(price, p.getAttribute('data-compare'));
        });
      });
    });

    /* ---- REVIEWS CAROUSEL nav ------------------------------------------ */
    $$('.bml-revc').forEach(function (c) {
      var track = $('.bml-revc__track', c);
      if (!track) return;
      var prev = $('.bml-revc__prev', c), next = $('.bml-revc__next', c);
      var step = function () {
        var card = track.querySelector('.bml-revc__card');
        return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });

    /* ---- STICKY MOBILE BAR --------------------------------------------- */
    var sticky = $('.bml-sticky');
    var buy = $('.bml-buy');
    function updateStickyPrice(now, was) {
      if (!sticky) return;
      var n = $('.bml-sticky__now', sticky), w = $('.bml-sticky__was', sticky);
      if (n && now) n.textContent = now;
      if (w) { if (was) { w.textContent = was; w.style.display = ''; } else { w.style.display = 'none'; } }
    }
    window.updateStickyPrice = updateStickyPrice;
    if (sticky) {
      var priceSource = buy ? (buy.querySelector('[data-bml-total]') || buy.querySelector('.bml-single__price')) : null;
      if (priceSource) {
        var mirror = function () { updateStickyPrice(priceSource.textContent.trim(), null); };
        try { new MutationObserver(mirror).observe(priceSource, { childList: true, characterData: true, subtree: true }); } catch (e) {}
      }
      var btn = $('.bml-sticky__btn', sticky);
      if (btn) btn.addEventListener('click', function () {
        var target = document.getElementById('bml-buy-anchor') || buy;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var footer = document.querySelector('footer') || document.querySelector('.bml-testi');
      function onScroll() {
        var showFrom = window.innerHeight * 0.9;
        var past = window.scrollY > showFrom;
        var nearFooter = false;
        if (footer) { var r = footer.getBoundingClientRect(); nearFooter = r.top < window.innerHeight - 20; }
        var buyVisible = false;
        if (buy) { var br = buy.getBoundingClientRect(); buyVisible = br.bottom > 0 && br.top < window.innerHeight; }
        sticky.classList.toggle('is-visible', past && !nearFooter && !buyVisible);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    /* ---- Secondary CTA buttons: scroll to buy (never add to cart) ------- */
    $$('.bml-cta2').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = document.getElementById('bml-buy-anchor') || buy;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---- Custom media sections: buffer videos on boot ------------------ */
    $$('video[data-bml-video]').forEach(function (v) { try { v.preload = 'auto'; v.load(); } catch (e) {} });
  });
})();
